import { AssetsService } from "../../data/assets.service";
import { LayoutsService } from "../../layout/layouts.service";


class GlobalUriLoader {
    private readonly assetsService = new AssetsService();
    private readonly layoutsService = new LayoutsService();

    private cache = new Map<string, string>();
    private pending = new Map<string, Promise<string>>();
    private listeners = new Set<() => void>();

    public async getDependentAssetUri(
        tag: string,
        forceRefresh = false
    ): Promise<string> {
        if (!forceRefresh) {
            const cached = this.cache.get(tag);
            if (cached) return cached;

            const inFlight = this.pending.get(tag);
            if (inFlight) return inFlight;
        }

        const request = this.fetchAndCache(tag);
        this.pending.set(tag, request);

        try {
            return await request;
        } finally {
            this.pending.delete(tag);
        }
    }

    private async fetchAndCache(tag: string): Promise<string> {
        const layout = await this.layoutsService.handleGetLayoutContainer(
            undefined,
            undefined,
            tag,
            5,
            true
        );

        const uri = this.assetsService.getDependentAssetUri(layout?.content ?? "");

        this.cache.set(tag, uri);
        this.emitChange();

        return uri;
    }

    public invalidate(tag?: string): void {
        if (tag) {
            this.cache.delete(tag);
            this.pending.delete(tag);
        } else {
            this.cache.clear();
            this.pending.clear();
        }

        this.emitChange();
    }

    public getCached(tag: string): string | undefined {
        return this.cache.get(tag);
    }

    public subscribe(listener: () => void): () => void {
        this.listeners.add(listener);
        return () => this.listeners.delete(listener);
    }

    private emitChange(): void {
        this.listeners.forEach((listener) => listener());
    }
}

export const globalUriLoader = new GlobalUriLoader();